// extracted by mini-css-extract-plugin
export default {"image":"IX-z","loaded":"JX-z"};